import { createFileRoute } from "@tanstack/react-router";
import { BadgePage } from "./-badge/BadgePage";

/** Public, unauthenticated "Secured on Guv" summary. The param is the badge id (the project slug in mocks). */
export const Route = createFileRoute("/badge/$project")({
  staticData: { title: "Secured on Guv" },
  component: BadgePage,
});
